import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from '@otcmarketsgroup/otcm-ui-lib';
import { appStatuses } from '../../constants';

const ProfileStatusDialog = ({
    open,
    statusId,
    onDismiss,
    onStartUpdate,
    onOpenCancel,
    onOpenReopen
}) => {
    const isNoApplication = statusId === appStatuses.NO_APPLICATION;
    const isInProgress = statusId === appStatuses.IN_PROGRESS;
    const isSubmitted = statusId === appStatuses.SUBMITTED;
    const isPendingReview = statusId === appStatuses.PENDING_REVIEW;
    const isUnderReview = statusId === appStatuses.UNDER_REVIEW;

    return (
        <Dialog open={open} showBrandedTop>
            {isNoApplication && <>
                <DialogTitle title='Verify Your Company Profile' onClose={onDismiss} />
                <DialogContent>
                    <Typography variant='body1'>
                        A <b>Verified Profile</b> badge will display for 6 months from the date of verification. Note that all changes will be reviewed by OTC Markets before they are publicly displayed.
                    </Typography>
                </DialogContent>
                <Divider />
                <DialogActions sx={{ flexDirection: 'column' }}>
                    <Button fullWidth onClick={onStartUpdate}>Start</Button>
                    <Button fullWidth variant='outlined' onClick={onDismiss}>View Only Mode</Button>
                </DialogActions>
            </>}

            {isInProgress && <>
                <DialogTitle title='Profile Changes in Progress' onClose={onDismiss} />
                <DialogContent>
                    <Typography variant='body1'>
                        You have started to make changes to your company profile. You may continue editing or select Discard Changes below to start a new profile verification.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ flexDirection: 'column' }}>
                    <Button fullWidth onClick={onDismiss}>Continue Editing</Button>
                    <Button fullWidth variant='outlined' color='warning' onClick={onOpenCancel}>Discard Changes</Button>
                </DialogActions>
            </>}

            {isSubmitted && <>
                <DialogTitle title='Company Profile Submitted' onClose={onDismiss} />
                <DialogContent>
                    <Typography variant='body1'>
                        Your company profile changes have been submitted and are pending review by OTC Markets. You may View the submitted changes, Reopen to modify your submission, or Discard Changes to retract submitted changes.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ flexDirection: 'column' }}>
                    <Button fullWidth onClick={onDismiss}>View Submitted Profile</Button>
                    <Button fullWidth variant='outlined' onClick={onOpenReopen}>Reopen</Button>
                    <Button fullWidth variant='outlined' color='warning' onClick={onOpenCancel}>Discard Changes</Button>
                </DialogActions>
            </>}

            {(isPendingReview || isUnderReview) && <>
                <DialogTitle title='Company Profile Under Review' onClose={onDismiss} />
                <DialogContent>
                    <Typography variant='body1'>
                        OTC Markets is currently making the requested changes to your profile. Editing access will be restored once it is complete.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ flexDirection: 'column' }}>
                    <Button fullWidth onClick={onDismiss}>View Submitted Profile</Button>
                </DialogActions>
            </>}
        </Dialog>
    );
};

ProfileStatusDialog.propTypes = {
    open: PropTypes.bool,
    statusId: PropTypes.string,
    onDismiss: PropTypes.func,
    onStartUpdate: PropTypes.func,
    onOpenCancel: PropTypes.func,
    onOpenReopen: PropTypes.func
};

export default ProfileStatusDialog;
